<app-banner></app-banner>
@if (data.CLOCK_START < today){
    <div class="width-container">
            <app-countdown-clock [targetDate]="data.CLOCK_END" ></app-countdown-clock>
    </div>

}

<section class="main-section confirmation white-bg">
    <div class="width-container">
        <h2 id="confirm-header" tabindex="-1" class="no-outline" [innerHtml]="'CONFIRM.HEAD' | translate:data"></h2>
        <p [innerHtml]="'CONFIRM.DESC' | translate:data"></p>
        <p [innerHtml]="'CONFIRM.REGISTRATION_DATE' | translate:data"></p>
        <p [innerHtml]="'CONFIRM.FOOTNOTE' | translate"></p>
    </div>
</section>